import React,{useState, useEffect} from 'react'
//firebase stuff
import {firebase} from './firebase';
import {db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs,updateDoc, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';
import {getStorage,ref, uploadBytes, listAll, getDownloadURL} from 'firebase/storage'
//this is the var we created in OUR firebase settings file. Not the firebase modules
import {storage} from './firebase'

//redux
import { useSelector, useDispatch} from 'react-redux';
import {changePhoto, changeUserName,setPhoto,setReduxUserID} from "./redux/isLoggedIn"
import {setFirstAppLoad } from "./redux/firstAppLoad"

import './css/EditAccount.css';



function ImageUploader() {
     const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);
     const reduxFirstAppLoad = useSelector((state) => state.firstAppLoad.reduxFirstAppLoad);
     const reduxIsLoggedIn = useSelector((state) => state.isLoggedIn.reduxIsLoggedIn);
     const reduxUserName = useSelector((state) => state.isLoggedIn.reduxUserName);
     const reduxUserPhoto = useSelector((state) => state.isLoggedIn.reduxUserPhoto);


     let dispatch = useDispatch();
     
     const userHeadshotRef = doc(db,"users",reduxUserID);
      
     const [imageUpload,setImageUpload] = useState();
     const [imageList,setImageList] = useState([]);
     const [loading, setLoading] = useState(false);
     
     //grab all the images in whatever folder
     const imageListRef = ref(storage,reduxUserID+"/");

     const uploadImage = () => {
          if(imageUpload == null){
               return;
          }
          //while uploading the new pic, show a loader
          setLoading(true);


          //make an upload path target
          const imagePath = reduxUserID+"/"+Date.now()+imageUpload.name; 
          const imageRef = ref(storage,imagePath);


          //in the then() callback, update the imageList[] so all the images display everytime a new one is uploaded
          uploadBytes(imageRef,imageUpload)
          .then( (snapshot) => {
               getDownloadURL(snapshot.ref).then((url)=>{
                    setImageList( (prev)=> [...prev,url] );
                    //put the url of where the image is stored in the FB storage into the DB user document
                    updateDoc(userHeadshotRef, { headshot: url });
                    window.localStorage.setItem('userPhoto', url );
                    dispatch(setPhoto(url)); 
                    setImageUpload(undefined);
                    setLoading(false);
               })  
               
               


          })//end then()
     }//end uploadImage()


     useEffect( () =>{
          //this is how FB makes you grab the image URLS.
          //put it in useEffect to display on pageload
          //we also have to put similar code on the button click to the new image is added to the page and not just the DB
          listAll(imageListRef).then( (response) => {
               response.items.forEach( (item) => {
                    getDownloadURL(item).then((url)=>{
                        setImageList((prev) => [...prev, url]);      
                    })
               })
          })

          
          
     },[reduxUserID]);



     return (
          <div>
               {/* a little hack to change the style of the file upload button */}
               {loading &&
                    <div className='overlayLoading'></div>
               }

               
               <label htmlFor="file-upload" 
               className="currentHeadshot"
               style={{backgroundImage:"url(" + reduxUserPhoto + ")"}} 
               
               >
               <div className='headshotEditButton'></div>     
               <i className="fa fa-cloud-upload"></i>
               </label>
               
               <input type='file' onChange={(event) => {setImageUpload(event.target.files[0]);  uploadImage();   }}  className="currentHeadshot" id="file-upload"/>
               {
               imageUpload != undefined && 
                    <div>
                         {console.log(imageUpload.name)}
                         <button onClick={uploadImage} className="uploadButton">Upload <span>{imageUpload.name}</span></button>
                    </div>
               }
               {
               imageUpload == undefined && 
                    <div>
                         <button className="uploadButtonGray">Upload</button>
                    </div>
               }               
             
               {/* <img src={reduxUserPhoto} className="currentHeadshot" onClick={(event) => {setImageUpload(event.target.files[0])}} /> */}

               
               

               {
               // imageList.map((url)=>{
               //      return <img src={url} key={url} />
               // })
               }


          </div>
     )
}

export default ImageUploader
